<div [class]="cssClassName" (click)="onClick()">
    <img
        [src]="image.frontImage"
        alt="{{ product.productLineName }}"
        (load)="onImageLoad(image.frontImage)"
        (error)="onImageLoad(image.frontImage)"
    />
</div>
